import { Injectable } from '@angular/core';
import {
  TabDetailPanelSettings,
} from '@common-modules/dependencies/navigation/tab-detail-component';
import { TabDetailPanelParameters } from '@common-modules/dependencies/navigation/tab-detail-panel-parameters';
import { RightPanelService } from '@common-modules/shared/navigation/right-panel.service';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { SidePanelService } from './side-panel.service';

/**
 * This class could potentially be out of this module and be provided
 * by an external module (ThinClientApp) so the SidePanelModule
 * remains uncoupled
 */

@Injectable()
export class SidePanelImplService extends SidePanelService {
  private _visibility$ = new ReplaySubject<boolean>(1);
  private _hover$ = new ReplaySubject<boolean>(1);
  private _hasPanel$ = new ReplaySubject<boolean>(1);

  readonly visibility$ = this._visibility$.asObservable();
  readonly hover$ = this._hover$.asObservable();
  readonly hasPanel$ = this._hasPanel$.asObservable();

  constructor(private _rpService: RightPanelService) {
    super();

    this.bindObservables();
  }

  toggleVisibility(): void {
    this._rpService.toggleVisibility();
  }

  toggleHover(): void {
    this._rpService.toggleHover();
  }

  setTabSettings(settings: TabDetailPanelSettings): void {
    this._rpService.setTabSettings(settings);
  }

  setTabParameters(params: TabDetailPanelParameters): void {
    this._rpService.setTabParameters(params);
  }

  private bindObservables(): void {
    this.bindSingle(this._rpService.visibilityObservable(), this._visibility$);
    this.bindSingle(this._rpService.HoverObservable(), this._hover$);
    this.bindSingle(this._rpService.hasRightPanelObservable(), this._hasPanel$);
  }

  private bindSingle(source$: Observable<any>, target$: Subject<any>): void {
    source$.subscribe((value) => {
      target$.next(value);
    });
  }
}
